import { type ApolloClient, type NormalizedCacheObject } from '@apollo/client'

import { type UserLocation, GetUserLocationDocument } from '@/generated/graphql-types'
import { initializeApollo } from '@/lib/apollo/apolloClient'

export type SearchLocation = {
  /** Defines locationID */
  id?: string
  /**
   * Defines if maps is rendered with radius or points to an exact location
   */
  isRegion?: boolean
  /**
   * Defines initial selected latitude
   */
  latitude: number | null
  /**
   * Defines initial selected longitude
   */
  longitude: number | null
  /**
   * Defines initial search radius
   */
  radius: number
  /**
   * Defines initial street address
   */
  streetAddress?: string
}

export const updateUserLocationCache = (
  location: UserLocation,
  client?: ApolloClient<NormalizedCacheObject>
) => {
  if (!client) {
    client = initializeApollo()
  }

  client.cache.writeQuery({
    query: GetUserLocationDocument,
    data: { userLocation: location },
  })
}
